/* tslint:disable */
import {
  Profile,
  Player,
  Address,
  Library,
  InvitationCode,
  ChatRoom,
  LimitedTimeOffer,
  PlayerGroup,
  ScreenCategory,
  PlayerSerial
} from '../index';

declare var Object: any;
export interface KanvasUserInterface {
  "id": string;
  "firstname": string;
  "lastname": string;
  "company": string;
  "invitationcode"?: string;
  "AccountActivated": boolean;
  "LockedOut": boolean;
  "LastLoginDate"?: Date;
  "LastLoginIp"?: string;
  "LastLoginGeoIp"?: any;
  "LastPasswordChangeDate"?: Date;
  "LastLockOutDate"?: Date;
  "Comment"?: string;
  "ClientID"?: number;
  "FailedPasswordAttemptCount"?: number;
  "FailedPasswordAtteptWindowStart"?: Date;
  "V1PasswordHash"?: string;
  "V1PasswordSalt"?: string;
  "realm"?: string;
  "username"?: string;
  "email": string;
  "emailVerified"?: boolean;
  "parentId"?: string;
  "parentContributorId"?: string;
  "parentClientId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "password"?: string;
  parentOperator?: KanvasUser;
  parentContributor?: KanvasUser;
  parentClient?: KanvasUser;
  roles?: any[];
  profile?: Profile;
  accessTokens?: any[];
  players?: Player[];
  billingAddress?: Address;
  privateLibrary?: Library;
  publicLibrary?: Library;
  invitationCodes?: InvitationCode[];
  chatRooms?: ChatRoom[];
  limitedTimeOffers?: LimitedTimeOffer[];
  playerGroups?: PlayerGroup[];
  screenCategories?: ScreenCategory[];
  playerSerials?: PlayerSerial[];
}

export class KanvasUser implements KanvasUserInterface {
  "id": string;
  "firstname": string;
  "lastname": string;
  "company": string;
  "invitationcode": string;
  "AccountActivated": boolean;
  "LockedOut": boolean;
  "LastLoginDate": Date;
  "LastLoginIp": string;
  "LastLoginGeoIp": any;
  "LastPasswordChangeDate": Date;
  "LastLockOutDate": Date;
  "Comment": string;
  "ClientID"?: number;
  "FailedPasswordAttemptCount": number;
  "FailedPasswordAtteptWindowStart": Date;
  "V1PasswordHash": string;
  "V1PasswordSalt": string;
  "realm": string;
  "username": string;
  "email": string;
  "emailVerified": boolean;
  "parentId": string;
  "parentContributorId": string;
  "parentClientId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "password": string;
  parentOperator: KanvasUser;
  parentContributor: KanvasUser;
  parentClient: KanvasUser;
  roles: any[];
  profile: Profile;
  accessTokens: any[];
  players: Player[];
  billingAddress: Address;
  privateLibrary: Library;
  publicLibrary: Library;
  invitationCodes: InvitationCode[];
  chatRooms: ChatRoom[];
  limitedTimeOffers: LimitedTimeOffer[];
  playerGroups: PlayerGroup[];
  screenCategories: ScreenCategory[];
  playerSerials: PlayerSerial[];
  constructor(data?: KanvasUserInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `KanvasUser`.
   */
  public static getModelName() {
    return "KanvasUser";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of KanvasUser for dynamic purposes.
  **/
  public static factory(data: KanvasUserInterface): KanvasUser{
    return new KanvasUser(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'KanvasUser',
      plural: 'KanvasUsers',
      path: 'KanvasUsers',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "firstname": {
          name: 'firstname',
          type: 'string'
        },
        "lastname": {
          name: 'lastname',
          type: 'string'
        },
        "company": {
          name: 'company',
          type: 'string'
        },
        "invitationcode": {
          name: 'invitationcode',
          type: 'string',
          default: 'null'
        },
        "AccountActivated": {
          name: 'AccountActivated',
          type: 'boolean',
          default: true
        },
        "LockedOut": {
          name: 'LockedOut',
          type: 'boolean',
          default: false
        },
        "LastLoginDate": {
          name: 'LastLoginDate',
          type: 'Date',
          default: new Date(0)
        },
        "LastLoginIp": {
          name: 'LastLoginIp',
          type: 'string',
          default: 'null'
        },
        "LastLoginGeoIp": {
          name: 'LastLoginGeoIp',
          type: 'any',
          default: <any>null
        },
        "LastPasswordChangeDate": {
          name: 'LastPasswordChangeDate',
          type: 'Date',
          default: new Date(0)
        },
        "LastLockOutDate": {
          name: 'LastLockOutDate',
          type: 'Date',
          default: new Date(0)
        },
        "Comment": {
          name: 'Comment',
          type: 'string',
          default: 'null'
        },
        "ClientID": {
          name: 'ClientID',
          type: 'number',
          default: 0
        },
        "FailedPasswordAttemptCount": {
          name: 'FailedPasswordAttemptCount',
          type: 'number',
          default: 0
        },
        "FailedPasswordAtteptWindowStart": {
          name: 'FailedPasswordAtteptWindowStart',
          type: 'Date',
          default: new Date(0)
        },
        "V1PasswordHash": {
          name: 'V1PasswordHash',
          type: 'string',
          default: 'null'
        },
        "V1PasswordSalt": {
          name: 'V1PasswordSalt',
          type: 'string',
          default: 'null'
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "parentId": {
          name: 'parentId',
          type: 'string'
        },
        "parentContributorId": {
          name: 'parentContributorId',
          type: 'string'
        },
        "parentClientId": {
          name: 'parentClientId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        parentOperator: {
          name: 'parentOperator',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'parentId',
          keyTo: 'id'
        },
        parentContributor: {
          name: 'parentContributor',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'parentContributorId',
          keyTo: 'id'
        },
        parentClient: {
          name: 'parentClient',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'parentClientId',
          keyTo: 'id'
        },
        roles: {
          name: 'roles',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
          modelThrough: 'RoleMapping',
          keyThrough: 'roleId',
          keyFrom: 'id',
          keyTo: 'principalId'
        },
        profile: {
          name: 'profile',
          type: 'Profile',
          model: 'Profile',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        players: {
          name: 'players',
          type: 'Player[]',
          model: 'Player',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
        billingAddress: {
          name: 'billingAddress',
          type: 'Address',
          model: 'Address',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'BillingAddressId'
        },
        privateLibrary: {
          name: 'privateLibrary',
          type: 'Library',
          model: 'Library',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId_privateLibrary'
        },
        publicLibrary: {
          name: 'publicLibrary',
          type: 'Library',
          model: 'Library',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId_publicLibrary'
        },
        invitationCodes: {
          name: 'invitationCodes',
          type: 'InvitationCode[]',
          model: 'InvitationCode',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
        chatRooms: {
          name: 'chatRooms',
          type: 'ChatRoom[]',
          model: 'ChatRoom',
          relationType: 'hasMany',
          modelThrough: 'ChatRoomKanvasUser',
          keyThrough: 'chatRoomId',
          keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
        limitedTimeOffers: {
          name: 'limitedTimeOffers',
          type: 'LimitedTimeOffer[]',
          model: 'LimitedTimeOffer',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
        playerGroups: {
          name: 'playerGroups',
          type: 'PlayerGroup[]',
          model: 'PlayerGroup',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
        screenCategories: {
          name: 'screenCategories',
          type: 'ScreenCategory[]',
          model: 'ScreenCategory',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
        playerSerials: {
          name: 'playerSerials',
          type: 'PlayerSerial[]',
          model: 'PlayerSerial',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'kanvasUserId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/KanvasUser.ts